module.exports = __webpack_public_path__ + "static/media/m (1).cfe8cf0a.jpg";